import { Text } from "north.js";
import React from "react";
import styled from "styled-components";

import { Header, PageWrapper, Spinner } from "src/shared/components";
import { useEventContext } from "src/shared/contexts";
import globalConstants from "src/theme/globalConstants";

const HackerDirectoryGate: React.FC = ({ children }) => {
  const { hackerDirectory, isLoading } = useEventContext();

  if (isLoading) {
    return <Spinner text="Loading Hacker Directory..." />;
  }

  if (!hackerDirectory.directoryEnabled) {
    return (
      <>
        <Header
          title="Hacker Directory"
          subtitle="Looking for teammates? Browse for hackers that match your skills and interests!"
        />
        <PageWrapper>
          <ComingSoon>
            <Text type="h2">We’re getting the Hacker Directory ready!</Text>
            <Text
              type="body1"
              style={{
                color: globalConstants?.color?.textSecondary as string,
              }}
            >
              The Hacker Directory isn’t open just yet. Check back soon to find
              and connect with potential teammates.
            </Text>
          </ComingSoon>
        </PageWrapper>
      </>
    );
  }

  return <>{children}</>;
};

const ComingSoon = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export default HackerDirectoryGate;
